const platform = {
	mobile: /(Android|iPhone|iPad|iPod|iOS)/i,
	ios: /\(i[^;]+;( U;)? CPU.+Mac OS X/,
	android: /Android/g
}

export const isMobile = () => {
	const userAgent = window.navigator.userAgent
	return platform.mobile.test(userAgent)
}